module.exports = __webpack_public_path__ + "static/android-icon-192x192-fd0da2b20d54ef0e815bf06927906d35.png";